export default __webpack_public_path__ + "static/media/navneet-gill-headshot-smiling-2.9f287455.jpg";